<dx-tabs
  [dataSource]="tabs"
  [selectedIndex]="selectedIndex"
  (onItemClick)="selectTab($event)"
></dx-tabs>
<app-map-sidebar-filter></app-map-sidebar-filter>
